export default {
    routerName: 'タグ編集',
    tag: {
        icon: 'アイコン',
        name: 'タグ名',
        status: '状態',
        open: '有効',
        close: '無効',
        sortOrder: 'ソート',
    },
};
